


















































































import { Component, Model, Prop, Watch } from 'vue-property-decorator';

import CheckIcon from '@/components/icons/Check.vue';

import InputBase from './InputBase.vue';
import InputWrapper from './InputWrapper.vue';

@Component<SelectionBox>({
  components: {
    InputWrapper,
    CheckIcon
  },
  computed: {
    isChecked() {
      if (this.type === 'radio') {
        return this.modelValue === this.value;
      }

      return Boolean(this.modelValue);
    }
  }
})
export default class SelectionBox extends InputBase {
  @Model('input') modelValue!: any;

  @Prop({ default: 'checkbox' }) type?: string;
  @Prop(String) value!: string;
  @Prop(String) name!: string;
  @Prop(String) title!: string;
  @Prop() description?: string;
  @Prop() subDescription?: string;
  @Prop({ default: 'medium' }) size!: 'small' | 'medium';
  @Prop() tag?: string;
  @Prop({ default: false }) isDisabled?: boolean;
  @Prop({ default: false }) hideCheck?: boolean;
  @Prop({ default: 'row' }) flexDirection?: string;
  @Prop({ default: 'flex-start' }) alignItems?: string;

  get helpErrId() {
    return `err-${this.name}`;
  }

  get wrapperVars() {
    return `
      --direction: ${this.flexDirection};
      --align: ${this.alignItems};
    `;
  }

  @Watch('isDisabled')
  onIsDisabledChange() {
    if (this.isDisabled) {
      if (this.type === 'radio') {
        this.$emit('input', '');
        return;
      }

      this.$emit('input', false);
    }
  }

  onInput(event: any) {
    if (this.type === 'radio') {
      this.$emit('input', event.target.value);
      return;
    }

    this.$emit('input', event.target.checked);
    this.$emit('changed', event.target.name);
  }
}
